import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useLanguage, useRootStore } from "@/stores/RootStoreContext";
import { useAppBar } from "@/appBar/useAppBar";
import { SigningCompleteDialog } from "@/portfolio/signatures/signaturesComponents";
import {
  clearSigningRef,
  initSigningCompletePageAction,
  prepareState,
  readSigningRef,
} from "./signDocumentDomain";
import { SignDocumentPageView } from "./signingComponents";
import { singleValue } from "@/utils/queryParams";

const SigningCompletePage = observer(function SigningCompletePage() {
  const { queryParams, signDocument, messageStore, dispatch } = useRootStore();
  const appBar = useAppBar();
  const lang = useLanguage();
  const [ref] = useState(() => {
    const remembered = readSigningRef();
    clearSigningRef();
    return remembered;
  });
  useEffect(() => {
    if (ref) {
      dispatch(initSigningCompletePageAction(ref));
    }
  }, [dispatch, ref]);
  if (!ref) {
    const companyName = singleValue(queryParams["signing-complete-company"]) ?? "";
    return (
      <SigningCompleteDialog
        showSigningCompleteDialog={true}
        closeSigningCompleteDialog={() => {
          window.location.href = "https://app.dcompany.no";
        }}
        companyName={companyName}
      />
    );
  }
  return (
    <SignDocumentPageView
      state={prepareState(dispatch, signDocument, appBar, lang)}
      alertStore={messageStore}
    />
  );
});

export default SigningCompletePage;
